<div class="flex flex-col w-full h-full bg-white overflow-hidden">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <div class="flex justify-between items-start p-6 border-b border-gray-200">
    <div class="flex items-center gap-4 min-w-0">
      <div
        class="w-16 h-16 rounded-2xl bg-purple-50 text-purple-700 overflow-hidden flex items-center justify-center shrink-0"
      >
        <span class="text-lg font-semibold">
          {{ promotionForm.get("name")?.value?.charAt(0) || "P" }}
        </span>
      </div>

      <div class="flex flex-col min-w-0">
        <span
          class="text-xs text-purple-700 bg-purple-50 px-3 py-1 rounded-full w-fit mb-2"
        >
          Promotion
        </span>

        <h2 class="text-xl md:text-2xl font-semibold text-gray-900 truncate">
          {{ promotionForm.get("name")?.value || modalTitle }}
        </h2>

        <p class="text-sm text-gray-600 truncate">
          {{ promotionForm.get("code")?.value || "No discount code entered yet" }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="w-9 h-9 rounded-full border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50"
      (click)="closeDialog()"
    >
      ×
    </button>
  </div>

  <div
    class="grid grid-cols-2 md:grid-cols-4 gap-3 p-6 border-b border-gray-200"
  >
    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Promo Status</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ isUpdate ? "Existing" : "New" }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Discount Type</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ readableDiscountType }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Value</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ formattedDiscountValue }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">State</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ promotionForm.get("is_active")?.value ? "Active" : "Inactive" }}
      </strong>
    </div>
  </div>

  <div class="flex gap-2 overflow-x-auto p-4 border-b border-gray-200 bg-white">
    <button
      *ngFor="let tab of tabs"
      type="button"
      class="px-4 py-2 rounded-3xl border text-sm whitespace-nowrap"
      [class.bg-gray-950]="activeTab === tab.key"
      [class.text-white]="activeTab === tab.key"
      [class.border-gray-950]="activeTab === tab.key"
      [class.bg-white]="activeTab !== tab.key"
      [class.text-gray-700]="activeTab !== tab.key"
      [class.border-gray-200]="activeTab !== tab.key"
      (click)="activeTab = tab.key"
    >
      {{ tab.label }}
    </button>
  </div>

  <form
    class="flex-1 overflow-y-auto p-6 flex flex-col gap-6"
    [formGroup]="promotionForm"
    (ngSubmit)="handleSave($event)"
  >
    @if (activeTab === "overview") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Promotion Details
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Discount Name *
              </span>

              <input
                type="text"
                formControlName="name"
                placeholder="New Year's Sale"
                class="input"
                [class.!border-red-500]="!checkValidField('name')"
              />

              <span class="error" *ngIf="!checkValidField('name')">
                Promo name is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Discount Code *
              </span>

              <input
                type="text"
                formControlName="code"
                placeholder="SALE12"
                class="input"
                (input)="onCodeInput($event)"
                [class.!border-red-500]="!checkValidField('code')"
              />

              <span class="error" *ngIf="!checkValidField('code')">
                Promo code is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">Type *</span>

              <select
                formControlName="discount_type"
                class="input"
                [class.!border-red-500]="!checkValidField('discount_type')"
                (change)="discountTypeChanged($event)"
              >
                <option value="">Choose Discount Type</option>
                <option value="PERCENT">Percentage</option>
                <option value="FIXED">Fixed Amount</option>
              </select>

              <span class="error" *ngIf="!checkValidField('discount_type')">
                Promo type is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">Value *</span>

              <input
                type="text"
                formControlName="discount_value"
                [placeholder]="discountType === 'PERCENT' ? '10' : '25'"
                class="input"
                (keypress)="allowNumbersOnly($event)"
                [class.!border-red-500]="!checkValidField('discount_value')"
              />

              <span class="error" *ngIf="!checkValidField('discount_value')">
                Value is required
              </span>

              <span
                class="error"
                *ngIf="promotionForm.get('discount_value')?.hasError('max')"
              >
                Percent value cannot exceed 100
              </span>
            </label>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Salon & Service
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Select Salon *
              </span>

              <select
                formControlName="salon"
                class="input"
                [class.!border-red-500]="!checkValidField('salon')"
                (change)="loadServices($event)"
              >
                <option value="">Choose Salon</option>

                @for (salon of salons; track salon.salon_id) {
                  <option [value]="salon.salon_id">
                    {{ salon.name }}
                  </option>
                }
              </select>

              <span class="error" *ngIf="!checkValidField('salon')">
                Salon is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Select Service *
              </span>

              <select
                formControlName="service"
                class="input"
                [class.!border-red-500]="!checkValidField('service')"
              >
                <option value="">Choose Service</option>

                @for (service of services; track service.service_id) {
                  <option [value]="service.service_id">
                    {{ service.name }}
                  </option>
                }
              </select>

              <span class="error" *ngIf="!checkValidField('service')">
                Service is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Usage Limit *
              </span>

              <input
                type="text"
                formControlName="usage_limit_type"
                class="input"
                placeholder="100"
                (keypress)="allowNumbersOnly($event)"
                [class.!border-red-500]="!checkValidField('usage_limit_type')"
              />

              <span class="error" *ngIf="!checkValidField('usage_limit_type')">
                Usage limit is required
              </span>
            </label>

            <div class="pt-2">
              <mat-slide-toggle formControlName="is_active">
                Activate Promo
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </section>
    }

    @if (activeTab === "schedule") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Start Date
          </h3>

          <app-glo-date-picker
            [formControlInput]="fetchInputField('start_date')"
            [label]="'Start Date *'"
            [placeholder]="'Select date'"
            [classes]="inputClasses"
            [isRequired]="
              fetchInputField('start_date')?.invalid &&
              fetchInputField('start_date')?.touched
            "
          >
          </app-glo-date-picker>

          <span class="error" *ngIf="!checkValidField('start_date')">
            Promo start date is required
          </span>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            End Date
          </h3>

          <app-glo-date-picker
            [formControlInput]="fetchInputField('end_date')"
            [label]="'End Date *'"
            [placeholder]="'Select date'"
            [classes]="inputClasses"
            [isRequired]="
              fetchInputField('end_date')?.invalid &&
              fetchInputField('end_date')?.touched
            "
          >
          </app-glo-date-picker>

          <span class="error" *ngIf="!checkValidField('end_date')">
            Promo end date is required
          </span>
        </div>
      </section>
    }

    <div class="sticky bottom-0 bg-white pt-4 border-t border-gray-200">
      <div class="ml-auto flex justify-end gap-3">
        <button
          type="button"
          class="px-6 py-2 shadow rounded-3xl bg-white text-gray-900 border border-gray-200"
          (click)="closeDialog()"
        >
          Cancel
        </button>

        <button
          class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white"
          type="submit"
        >
          {{ isUpdate ? "Save Changes" : "Create Promotion" }}
        </button>
      </div>
    </div>
  </form>
</div>